import {
  DropdownButton,
  DropdownMenuItem,
  DropdownMenuSeparator,
  ModalAlert,
  Styles,
} from "@mixitone/components";
import UserIcon from "@mixitone/icons/user.svg";
import { ApplicationView } from "@mixitone/mvc";
import { AppController } from "controllers/AppController";
import tauri from "lib/tauri";
import { useCallback, useState } from "react";

const UserMenu = () => {
  const appController = AppController.use();
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const [signingOut, setSigningOut] = useState(false);

  const handleClickLogout = useCallback(() => {
    setShowSignOutModal(true);
  }, []);

  const handleLogout = useCallback(() => {
    setSigningOut(true);
    appController.actionSignOut();
  }, [appController]);

  const handleUpdater = useCallback(() => {
    appController.actionCheckForUpdates();
  }, [appController]);

  return (
    <>
      <DropdownButton
        className="user-menu"
        buttonComponent="button"
        buttonProps={{
          className: Styles.Buttons.buttonClasses({ kind: "topNav" }),
          style: { height: "var(--mixitone-header-height)" },
          title: "User menu",
        }}
        button={
          <div className="relative">
            <UserIcon className="h-6 w-6 text-white hover:stroke-slate-300" />
          </div>
        }
        dropdownTitle="Signed in"
        arrow
      >
        {tauri.enabled && import.meta.env.DEV && (
          <>
            <DropdownMenuItem
              value="updater"
              onClick={handleUpdater}
              closeOnClick
              className="flex items-center gap-2"
            >
              <div>Test update notification</div>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem value="signOut" onClick={handleClickLogout} closeOnClick>
          Sign out
        </DropdownMenuItem>
      </DropdownButton>
      {showSignOutModal && (
        <ModalAlert
          message={
            <section>
              <p>Are you sure you want to sign out?</p>
              {tauri.enabled && <p>You need to be connected to the internet to sign back in.</p>}
            </section>
          }
          onConfirm={handleLogout}
          loading={signingOut}
          title={"Sign out"}
          onCancel={() => {
            setShowSignOutModal(false);
          }}
          confirmText={"Sign out"}
          confirmKind="danger"
          cancelText={"Stay signed in"}
        />
      )}
    </>
  );
};

export default ApplicationView(UserMenu);
